import { render, staticRenderFns } from "./NavDates.vue?vue&type=template&id=5aae6a86&scoped=true&"
import script from "./NavDates.vue?vue&type=script&lang=js&"
export * from "./NavDates.vue?vue&type=script&lang=js&"
import style0 from "./NavDates.vue?vue&type=style&index=0&id=5aae6a86&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aae6a86",
  null
  
)

export default component.exports